import React from 'react';
import { FaArrowLeft, FaBackward } from 'react-icons/fa';
import { useLoaderData, useNavigate } from 'react-router-dom';

const Payments = () => {
    const paymentCustomer = useLoaderData()
    const navigation = useNavigate();
    // console.log(paymentCustomer);
    const handleBack=()=>{
        navigation('/customer')
    }
    return (
        <div>
        <div className='w-full p-4 flex justify-start'><button onClick={handleBack} className='btn btn-ghost'><FaArrowLeft size={24}></FaArrowLeft></button></div>
           <div className='mx-10 mt-5'>
           <div className="divider"></div> 
            <h2 className='text-center text-3xl font-semibold'>গ্রাহক নাম : {paymentCustomer.customerName}</h2>
            <div className="divider"></div> 
            <div className='flex flex-col gap-4 mt-8 w-full'>
            <h2 className='text-start text-2xl'>আইডি : {paymentCustomer.customerId}</h2>
            <h2 className='text-start text-2xl'>মোবাইল : {paymentCustomer.customerNumber}</h2>
            <h2 className='text-start text-2xl'>মাসিক ফি : {paymentCustomer.monthlyFee}</h2>
            <h2 className='text-start text-2xl'>বকেয়া রয়েছে : {paymentCustomer.stupidity}</h2>
            </div>
            <div className="divider"></div> 
            <div className='my-6'>
            <h2 className='text-center text-3xl'>{paymentCustomer.lastPayment.paymentDate} এই মাসের বিল {paymentCustomer.lastPayment.payAmount} টাকা পরিশোধ করার জন্য ধন্যবাদ।</h2>
            </div>
            <div className="divider"></div> 
            <div className='mt-10'>
                <h3 className='text-sm text-center'>বিঃদ্রঃ : অনুগ্রহ করে রেসিপি ভালো করে সংগ্রহ করে রাখুন ।</h3>
            </div>
           </div>
        </div>
    );
};

export default Payments;